import api from './api';
import { ApiResponse } from '../types';

export interface StyleMatcherDress {
  id: string;
  name: string;
  image: string;
  designer: string | null;
  categories: string[];
}

export interface SwipeRequest {
  dressId: string;
  action: 'like' | 'pass' | 'skip';
}

export interface SwipeResponse {
  recorded: boolean;
}

export interface StyleMatcherResults {
  totalSwipes: number;
  likes: number;
  passes: number;
  skips: number;
  categoryPreferences: Record<string, number>;
  recommendedDresses: any[];
  sessionId: string;
}

export interface NewSessionResponse {
  sessionId: string;
}

class StyleMatcherService {
  async getStyleMatcherDresses(): Promise<StyleMatcherDress[]> {
    const response = await api.get<ApiResponse<StyleMatcherDress[]>>('/style-matcher/dresses');
    return response.data.data;
  }

  async recordSwipe(dressId: string, action: 'like' | 'pass' | 'skip'): Promise<SwipeResponse> {
    const response = await api.post<ApiResponse<SwipeResponse>>('/style-matcher/swipe', {
      dressId,
      action
    });
    return response.data.data;
  }

  async getResults(sessionId?: string): Promise<StyleMatcherResults> {
    const params = sessionId ? { sessionId } : {};
    const response = await api.get<ApiResponse<StyleMatcherResults>>('/style-matcher/results', params);
    return response.data.data;
  }

  async startNewSession(): Promise<NewSessionResponse> {
    const response = await api.post<ApiResponse<NewSessionResponse>>('/style-matcher/new-session');
    return response.data.data;
  }
}

export default new StyleMatcherService();